import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import axios from "axios";
import Navbar from "./Navbar";

const AppointmentSummaryNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchAppointments = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/appointment_summary",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setAppointments(response.data.summary);
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />

      {/* Main Container */}
      <div className="flex justify-center items-start px-4 sm:px-6 md:px-8 pt-28 pb-12">
        <div className="w-full max-w-3xl bg-white rounded-3xl shadow-xl border border-indigo-100 p-6 sm:p-10 transition-all">

          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-indigo-100 p-3 rounded-full shadow-md">
              <CalendarDays className="w-7 h-7 sm:w-9 sm:h-9 text-indigo-600" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-semibold text-indigo-800">
              Appointment Summary
            </h1>
          </div>

          {/* Appointment List */}
          {isLoading ? (
            <div className="text-center text-indigo-600 font-medium text-lg">
              Loading appointments...
            </div>
          ) : !appointments? (
            <div className="text-center text-gray-600 font-medium text-lg">
              No appointments found for this patient.
            </div>
          ) : (
            <div className="space-y-4">
                <div
                  className="relative bg-gradient-to-br from-white/80 to-indigo-50/70 backdrop-blur-md text-gray-800 p-5 sm:p-7 rounded-2xl text-base sm:text-lg border border-indigo-200 shadow-md hover:shadow-lg transition-all duration-300"
                >
                  <p className="italic text-gray-600">
                    Notes: {appointments|| "No notes"}
                  </p>
                </div>
              
            </div>
          )}

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto bg-gradient-to-r from-indigo-500 to-blue-600 hover:from-indigo-600 hover:to-blue-700 text-white font-semibold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSummaryNote;
